import { persist } from 'zustand/middleware';

import { createStore } from '@store/createStore';

const useAppStorePersist = createStore(
  persist(
    (set) => ({
      i18n: {},
      translationsHash: '',
      mapsVisible: true,
      sidebarResponse: false,
      refreshInterval: 300,
      onBoardStart: false,
      onBoardComplete: false,
      downtimeType: 0,
      darkMode: false,

      actions: {
        setAppPersistI18n: (i18n) => set({ i18n }),
        setAppPersistTranslationsHash: (translationsHash) => set({ translationsHash }),
        setAppPersistMapsVisible: (mapsVisible) => set({ mapsVisible }),
        setAppPersistSidebarResponse: (sidebarResponse) => set({ sidebarResponse }),
        setAppPersistRefreshInterval: (refreshInterval) => set({ refreshInterval }),
        setAppPersistOnBoardStart: (onBoardStart) => set({ onBoardStart }),
        setAppPersistOnBoardComplete: (onBoardComplete) => set({ onBoardComplete }),
        setAppPersistDowntimeType: (downtimeType) => set({ downtimeType }),
        setAppPersistDarkMode: (darkMode) => set({ darkMode }),
      },
    }),
    {
      version: 1,
      name: 'app-storage-persist',
      partialize: (state) => Object.fromEntries(Object.entries(state).filter(([key]) => key !== 'actions')),
    },
  ),
  'AppStorePersist',
);

export const useAppPersistActions = () => useAppStorePersist((state) => state.actions);

export const selectAppPersistI18n = () => useAppStorePersist((state) => state.i18n);
export const selectAppPersistTranslationsHash = () => useAppStorePersist((state) => state.translationsHash);
export const selectAppPersistMapsVisible = () => useAppStorePersist((state) => state.mapsVisible);
export const selectAppPersistSidebarResponse = () => useAppStorePersist((state) => state.sidebarResponse);
export const selectAppPersistRefreshInterval = () =>
  useAppStorePersist((state) => state.refreshInterval * 1000);
export const selectAppPersistOnBoardStart = () => useAppStorePersist((state) => state.onBoardStart);
export const selectAppPersistOnBoardComplete = () => useAppStorePersist((state) => state.onBoardComplete);
export const selectAppPersistDowntimeType = () => useAppStorePersist((state) => state.downtimeType);
export const selectAppPersistDarkMode = () => useAppStorePersist((state) => state.darkMode);
